/* tslint:disable */

/**
 */
export class CardMonthGeneralForm {
    from_date?: string;
    to_date?: string;
    barcode?: string;
}
